import axios from "axios";
import { urlConfig } from "../../config/urlConfig";
import { WorkInprogressModelDetails } from "../../types/WorkInProgressModel";
import { postCall } from "../httpService";

const baseUrl = process.env.REACT_APP_API_URL;
const workInProgressGet = urlConfig.WorkInProgressGet;
const workInProgressDelete = urlConfig.WorkInProgressDelete;

const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export const postWorkInProgressData = async (data: WorkInprogressModelDetails) => {
  try {
      const response = await postCall(workInProgressGet, data );
      return response.data;
  } catch (error) {
      console.error('Error fetching data', error);
      throw error;
  }
};

export const deleteWorkInProgressData = async (data: WorkInprogressModelDetails) => {
  try{
    const response=await postCall(workInProgressDelete, data);
    return response.data;
  }catch(error){
    console.error('Error in WIP data delete', error);
    throw error;
  }
};